import { SkeletonBox, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const MindMapSkeleton = () => (
  <div
    aria-hidden="true"
    style={{
      position: 'relative',
      width: '100%',
      height: 'min(70vh, 640px)',
      padding: 'var(--space-xl)',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--color-surface-subtle)',
      overflow: 'hidden',
    }}
  >
    {/* Faint grid background */}
    <SkeletonBox
      height="100%"
      width="100%"
      borderRadius="var(--radius-lg)"
      style={{ position: 'absolute', inset: 0, opacity: 0.25 }}
      variant="pulse"
    />

    {/* Edge stand-ins — thin pulse lines */}
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '70%',
          height: '60%',
          maxWidth: 720,
        }}
      >
        <SkeletonBox
          width="40%"
          height={2}
          borderRadius="0"
          variant="pulse"
          style={{ position: 'absolute', top: '40%', insetInlineStart: '15%' }}
        />
        <SkeletonBox
          width="40%"
          height={2}
          borderRadius="0"
          variant="pulse"
          style={{ position: 'absolute', top: '60%', insetInlineStart: '15%' }}
        />
        <SkeletonBox
          width="40%"
          height={2}
          borderRadius="0"
          variant="pulse"
          style={{ position: 'absolute', top: '50%', insetInlineEnd: '15%' }}
        />
      </div>
    </div>

    {/* Nodes (root + branches + leaves) */}
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'var(--space-2xl)',
      }}
    >
      {/* Left children */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-lg)' }}>
        <SkeletonCircle size={56} />
        <SkeletonCircle size={56} />
        <SkeletonCircle size={56} />
      </div>

      {/* Root */}
      <SkeletonCircle size={120} />

      {/* Right children */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-lg)' }}>
        <SkeletonCircle size={56} />
        <SkeletonCircle size={56} />
      </div>
    </div>

    {/* Toolbar */}
    <div
      style={{
        position: 'absolute',
        top: 'var(--space-md)',
        insetInlineStart: 'var(--space-md)',
        display: 'flex',
        gap: 'var(--space-sm)',
      }}
    >
      <SkeletonBox width={36} height={36} borderRadius="var(--radius-sm)" />
      <SkeletonBox width={36} height={36} borderRadius="var(--radius-sm)" />
      <SkeletonBox width={36} height={36} borderRadius="var(--radius-sm)" />
    </div>
  </div>
);

export default MindMapSkeleton;
